<template>
    <div class="export-statistics-view">
        <v-main>
            <year-month-range-picker v-model="period" @valid="onValid" />
            <v-row>
                <v-col>
                    <v-btn color="primary" :disabled="!valid" :loading="downloading" @click="download">
                        {{ t('mpcStatistics.resources.downloadStatistics') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-main>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import YearMonthRangePicker from './components/YearMonthRangePicker.vue';
import { useMpcStatisticsStore } from './mpcStatisticsStore';

const { t } = useI18n();
const store = useMpcStatisticsStore();
const period = ref({ from: store.monthlyPeriod.from, to: store.monthlyPeriod.to });
const valid = ref(true);
const downloading = ref(false);

function onValid(v: boolean) {
    valid.value = v;
}

async function download() {
    if (!valid.value) return;
    downloading.value = true;
    try {
        const url = await store.getExportUrl(period.value.from, period.value.to);
        const a = document.createElement('a');
        a.href = url;
        a.click();
    } finally {
        downloading.value = false;
    }
}
</script>
